import { Group } from './groups';
import { Site } from './site';
import { Location } from './washhub';

export type Permissions = Array<{
  role: RolesEnum;
  washHub: string;
  _id: string;
}>;

export type Customer = {
  createdAt: Date;
  updatedAt: Date;
  fname: string;
  lname: string;
  role: string;
  status: string;
  email: string;
  userId: string;
  username: string;
  phone: string;
  _id: string;
  permissions?: Permissions;
  companyName?: string;
  collectionPoint: string;
  collectionPointCode: string;
  isAuthenticated: boolean;
  type: string;
  billingContact: string;
  site: string;
  siteCode: string;
};

export type Employee = Customer & {
  permissions?: Permissions;
};

export type Company = {
  _id: string;
  companyName: string;
  userId: string;
  type: string;
  billingContact: string;
  status: string;
  permissions: Permissions;
  isAuthenticated: boolean;
  isDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
};

export type Contact = {
  _id: string;
  email: string;
  phone: string;
  role: string;
  washHub: Location;
  fname?: string;
  lname?: string;
  sites?: Site[];
  groups?: Group[];
  status?: string;
};

export enum RolesEnum {
  ADMIN = 'admin',
  SUPER_ADMIN = 'super_admin',
  WASH_HUB_ADMIN = 'wash_hub_admin',
  WASH_HUB_STAFF = 'wash_hub_staff',
  // CUSTOMER = 'customer',
}

export enum UserStatusEnum {
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  DELETED = 'deleted',
  DISABLED = 'disabled',
}

export enum ContactStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ARCHIVED = 'archived',
}
